import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import PointsBurst from "../../components/PointsBurst";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";

// Поздравительный попап о начислении баллов (дизайн Figma): 🎉 + текст по сумме
// начисления: +500 «Вы с партнёром прошли тест», +200 «друг прошёл +57», +100 «друг
// прошёл тест». Крестик -> вернуться к экрану (кнопка СМОТРЕТЬ под попапом),
// «Подробнее» -> ИНСТРУКЦИЯ.
export default function PointsCongratsModal() {
  const [payload, setPayload] = useState(null);
  // Task 2: анимация «+500» проигрывается ВНУТРИ попапа при его появлении
  // (в ЛК взрыв для +500 подавлен — см. Etap2SocketBridge). Гасится сама через onDone.
  const [showBurst, setShowBurst] = useState(false);
  const { t } = useTranslation();
  const { openModal, closeModal } = useModalActions();

  const amount = payload?.amount ?? 500;
  // текст зависит от суммы начисления; для нестандартных сумм — дефолтный.
  // Суммы попапов: 500 (Вы с партнёром прошли тест — обоим игрокам), 200 (друг прошёл
  // +57), 100 (друг прошёл тест). Покупка друга (+500 инвайтеру) попап НЕ показывает.
  const hasVariant = ["500", "200", "100"].includes(String(amount));
  const title = hasVariant
    ? t(`loyalty.congrats.variants.${amount}.title`)
    : t("loyalty.congrats.default_title", { amount });
  const text = hasVariant
    ? t(`loyalty.congrats.variants.${amount}.text`)
    : t("loyalty.congrats.default_text");

  return (
    <BaseModal
      className="points-congrats-modal"
      eventTypeModal={MODAL_TYPES.POINTS_CONGRATS}
      onPayload={(data) => {
        if (!data) return;
        setPayload(data);
        // Взрыв в попапе — ТОЛЬКО для +500 (его взрыв в ЛК подавлен). Для +100/+200
        // анимация уже проигралась в ЛК — второй раз в попапе не показываем.
        setShowBurst(Number(data.amount) === 500);
      }}
      title={
        <span className="points-congrats-modal__title">
          {showBurst && (
            <span className="points-congrats-modal__burst">
              <PointsBurst amount={amount} onDone={() => setShowBurst(false)} />
            </span>
          )}
          <span className="points-congrats-modal__emoji" role="img" aria-label="party">
            🎉
          </span>
          {title}
        </span>
      }
      description={text}
    >
      <BaseButton
        onClick={() => {
          closeModal(MODAL_TYPES.POINTS_CONGRATS);
          openModal(MODAL_TYPES.POINTS_INSTRUCTION);
        }}
      >
        {t("loyalty.congrats.details_btn")}
      </BaseButton>
    </BaseModal>
  );
}
